exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollAccountList{margin-left:0;left:10px}.accountDropdownItem{color:black}.accountDropdownItem:hover{cursor:pointer;color:black}.accountDropdownItem:focus{outline:none}.scrollAccountList{max-height:520px;overflow-y:auto}.sessionsMenuItem{color:black}.dropdownIcon{color:#50A3D9}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/Menus/SessionsMenu/style.scss
// module id = 6208
// module chunks = 0